import { StylesConfig } from 'react-select';

import { Colors } from 'appConstants';
import { SelectOption } from 'types';

export const registrationCustomStyles: StylesConfig<SelectOption<string>, false> = {
  option: (provided, { isSelected, isFocused }) => {
    let backgroundColor = Colors.BLACKTRANSPARENT;
    if (isFocused || isSelected) {
      backgroundColor = Colors.PINK;
    }

    return {
      ...provided,
      backgroundColor,
      backdropFilter: 'blur(2px)',
    };
  },
  menuList: (provided) => ({
    ...provided,
    '::-webkit-scrollbar': {
      width: '8px',
      height: '0px',
      borderRadius: 4,
    },
    '::-webkit-scrollbar-track': {
      background: Colors.TRANSPARENT,
      borderRadius: 4,
    },
    '::-webkit-scrollbar-thumb': {
      background: Colors.GRAY,
      borderRadius: 4,
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: Colors.BLUE,
    },
    maxHeight: '300px',
    overflow: 'auto',
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: 64,
    minWidth: 160,
    padding: 20,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: Colors.WHITE,
    fontWeight: 700,
    fontSize: 14,
    textAlign: 'left',
  }),

  placeholder: (provided) => ({
    ...provided,
    color: Colors.TEXT_COLOR,
    fontWeight: 500,
    fontSize: 14,
  }),

};
